import { render, staticRenderFns } from "./MainLogin.vue?vue&type=template&id=370e8201&scoped=true"
import script from "./MainLogin.vue?vue&type=script&lang=js"
export * from "./MainLogin.vue?vue&type=script&lang=js"
import style0 from "./MainLogin.vue?vue&type=style&index=0&id=370e8201&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370e8201",
  null
  
)

export default component.exports